<div *ngIf="oktaData && oktaData.length; else noData">
    <div class="hvac-row">
        <div class="hvac-col-xs-12 hvac-col-lg-6 layer-view-okta-data-details-col">
            <ul class="layer-view-okta-data-detail-list">
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.OKTA_DATA.LOGIN_ID' | translate}}</div>
                    <div class="hvac-col-xs layer-view-okta-data-list-value hvac-non-edit-mode">{{ oktaData[0].id | textFallback }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.OKTA_DATA.FIRST_NAME' | translate}}</div>
                    <div class="hvac-col-xs layer-view-okta-data-list-value hvac-non-edit-mode">{{ oktaData[0].firstName | textFallback }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.OKTA_DATA.LAST_NAME' | translate}}</div>
                    <div class="hvac-col-xs layer-view-okta-data-list-value hvac-non-edit-mode">{{ oktaData[0].lastName | textFallback }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.OKTA_DATA.EMAIL' | translate}}</div>
                    <div class="hvac-col-xs layer-view-okta-data-list-value hvac-non-edit-mode">{{ oktaData[0].email | textFallback }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.OKTA_DATA.STATUS' | translate}}</div>
                    <div class="hvac-col-xs layer-view-okta-data-list-value hvac-non-edit-mode">{{ oktaData[0].status | textFallback }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.OKTA_DATA.LAST_LOGIN' | translate}}</div>
                    <div class="hvac-col-xs layer-view-okta-data-list-value hvac-non-edit-mode">{{ oktaData[0].lastLoginDate ? (oktaData[0].lastLoginDate | dateTimeTz:'datetime') : '-' }}</div>
                </li>
            </ul>
        </div>
        <div class="hvac-col-xs-12 hvac-col-lg-6 layer-view-okta-data-details-col">
            <ul class="layer-view-okta-data-detail-list">
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.OKTA_DATA.LAST_UPDATED' | translate}}</div>
                    <div class="hvac-col-xs layer-view-okta-data-list-value hvac-non-edit-mode">{{ oktaData[0].lastUpdated ? (oktaData[0].lastUpdated | dateTimeTz:'datetime') : '-' }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.OKTA_DATA.PASSWORD_CHANGED' | translate}}</div>
                    <div class="hvac-col-xs layer-view-okta-data-list-value hvac-non-edit-mode">{{ oktaData[0].passwordChanged ? (oktaData[0].passwordChanged | dateTimeTz:'datetime') : '-' }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.OKTA_DATA.STATUS_CHANGED' | translate}}</div>
                    <div class="hvac-col-xs layer-view-okta-data-list-value hvac-non-edit-mode">{{ oktaData[0].statusChanged ? (oktaData[0].statusChanged | dateTimeTz:'datetime') : '-' }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.OKTA_DATA.CREATED_DATE' | translate}}</div>
                    <div class="hvac-col-xs layer-view-okta-data-list-value hvac-non-edit-mode">{{ oktaData[0].createdDate ? (oktaData[0].createdDate | dateTimeTz:'datetime') : '-' }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.OKTA_DATA.ACTIVATED' | translate}}</div>
                    <div class="hvac-col-xs layer-view-okta-data-list-value hvac-non-edit-mode">{{ oktaData[0].activatedDate ? (oktaData[0].activatedDate | dateTimeTz:'datetime') : '-' }}</div>
                </li>
            </ul>
        </div>
    </div>
</div>
<ng-template #noData>
    <p class="hvac-user-not-found">{{ 'USER_ADMIN.LAYER_VIEW.USER_NOT_FOUND_IN_OKTA' | translate}}</p>
</ng-template>

